import React from 'react'

function VideoDetail({ video }) {

    if (video === null) {
        return <div>Loading ....</div>
    }

    const videoSrc = `https:///www.youtube.com/embed/${video.id.videoId}`

    return (
        <div>
            <div className="ui embed">
                <iframe title='videos' src={videoSrc} frameBorder="0"></iframe>
            </div>
            <div className="ui segment">
                <h4 className='ui header'>{video && video.snippet.title}</h4>
                <p>{video && video.snippet.description}</p>
            </div>
        </div>
    )
}

export default VideoDetail
